import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { VideoMessageAPI } from '../../services/videoMessageAPI';
import moment from 'moment';
@inject(AuthService, UserMessageService, Router, VideoMessageAPI)
export class VideoMessageListtCustomElement {
    constructor(authService, userMessageService, router, videoMessageApi) {

        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.videoMessageApi = videoMessageApi;
    }

    limitPages = [
        { id: 10, name: '10' },
        { id: 50, name: '50' },
        { id: 100, name: '100' },
      ];

    activate() {
        this.dataList = null;
        this.count = null;
        this.limit = 10;
        this.page = 1;
        this.sortBy = "CREATE_DATE";
        this.sortDir = "DESC";
        this.selectedlimitPages = 10;


        this.load();
    }

    detached() {
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
    }


    load() {
        this.videoMessageApi.getList(
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    saveLoadSuccess(data) {
        this.setData(data);
        if(this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
            this.refreshTimeout = null;
        }
        this.refreshTimeout = setTimeout(this.load.bind(this), 10000);

    }

    saveLoadError(msg) {
        this.userMessageService.setUserError("user", msg);
    }

    setData(data) {
        this.dataList = data.list;
        this.dataList = this.dataList.map(function(value, index, array){
            if(value.is_scheduled && value.is_sent != 1){
               value.status_text =  'Scheduled [ ' + moment(value.gmt_time * 1000).format('MM/DD/YYYY hh:mm A') + ' ]';
            } 
            return value;
            
        });
        this.count = data.count;
        this.pages =  Math.floor(this.count / this.limit);
        this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
    }

    rowClicked(item, $event) {
        console.log("Item is ",item);
        console.log("event  is ",$event);
      // if(item.status == 0 || item.status == 3 || item.status == 100)
        this.router.navigate("video/message/" + item.id);
    }

    delete(item, $event) {
        $event.stopPropagation();
        if(confirm("Delete this video message?")) {
            this.videoMessageApi.deleteVideo(
            item,
            this.authService.getUser().token,
            this.deleteSuccess.bind(this),
            this.saveLoadError.bind(this));
        }




    }

    deleteSuccess(data) {
        this.load();
        this.userMessageService.setUserMessage("user", "Video Successfully Deleted");

    }

    columnClicked(name) {
        if (this.sortBy == name) {
            if (this.sortDir == "ASC")
                this.sortDir = "DESC";
            else
                this.sortDir = "ASC";
            this.load();
        } else {
            this.sortBy = name;
            this.sortDir = "DESC";
            this.load();
        }
    }

    prev() {
        if (this.page > 1) {
            this.page--;
            this.dataList = null;
            this.load();
        }
    }

    next() {
        if (this.page < this.pages) {
            this.page++;
            this.dataList = null;
            this.load();
        }
    }
    limitChange() {
        if(this.limit != this.selectedlimitPages){
        this.limit = this.selectedlimitPages;
        this.dataList = null;
        this.load();
        }
      }


}
